import { Box, Typography, useTheme, Tooltip } from "@mui/material";
import React from "react";

const DrawerHeader = ({
  headingText,
  setToggleDrawer,
  handleClose,
  assessmentChannel,
}) => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0px 16px",
          borderBottom: "1px solid #E9EAEB",
          height: "56px",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            padding: "12px 0px",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "24px",
            fontFamily: "Nunito",
            color: theme.palette.primary.black,
          }}
        >
          {headingText}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {(assessmentChannel?.name || assessmentChannel) && (
            <Tooltip title="Channel Name" arrow>
              <Typography
                sx={{
                  fontSize: "14px",
                  borderRadius: "5px",
                  bgcolor: "#d5f9f1",
                  padding: "4px 8px",
                  color: "#00C49A",
                  textTransform: "capitalize",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <img src="/assets/developementGreen.svg" alt="Development" />
                {assessmentChannel?.name || assessmentChannel}
              </Typography>
            </Tooltip>
          )}
          <Box
            component="img"
            color={theme.palette.gray.main}
            onClick={() => {
              handleClose && handleClose();
              setToggleDrawer((prev) => !prev);
            }}
            src="/assets/icons/x.svg"
            sx={{ cursor: "pointer" }}
          />
        </Box>
      </Box>
    </>
  );
};

export default DrawerHeader;
